import APP from 'src/main.js'
import Event from './Event.js'

class IncomeCancel extends Event {
  get income(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id===this.id)&&(rel.parent_type==='Income'))||{}).parent_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id===value)&&ev.id)
    } else {
      return null
    }
  }
  get income_received(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id=== this.id)&&(rel.parent_type==='IncomeReceived'))||{}).parent_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id===value)&&ev.id)
    } else {
      return null
    }
  }
  get coract_id(){
    return (this.income||{}).coract_id
  }
  set coract_id(v){v}
}
export default IncomeCancel
